import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  Component,
  inject,
  input,
  PLATFORM_ID,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ToastService } from '@front-share';
import { ButtonComponent } from '../button/button.component';
import { BaseInputComponent } from '../common/base-input.component';
import { LabelComponent } from '../label/label.component';

@Component({
  selector: 'app-input-tel',
  standalone: true,
  host: { ngSkipHydration: 'true' },
  imports: [CommonModule, FormsModule, ButtonComponent, LabelComponent],
  templateUrl: './input-tel.component.html',
  styleUrl: '../common/input.common.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputTelComponent,
      multi: true,
    },
  ],
})
export class InputTelComponent extends BaseInputComponent {
  max = input<number>(11);
  platformId = inject(PLATFORM_ID);
  toastService = inject(ToastService);
  customCss = input<string>('text-sm text-gray-800');
  verify = input<boolean, string | boolean>(false, {
    transform: booleanAttribute,
  });

  handleKeyup(event: KeyboardEvent): void {
    if (event.key.length === 1 && /\D/.test(event.key)) {
      event.preventDefault();
    }
  }
}
